import loadingReducer from './loading-reducer';

export default loadingReducer;
